var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.375C21.45 12.375 22.625 13.55 22.625 15C22.625 16.45 21.45 17.625 20 17.625C18.55 17.625 17.375 16.45 17.375 15C17.375 13.55 18.55 12.375 20 12.375ZM20 23.625C23.7125 23.625 27.625 25.45 27.625 26.25V27.625H12.375V26.25C12.375 25.45 16.2875 23.625 20 23.625ZM20 10C17.2375 10 15 12.2375 15 15C15 17.7625 17.2375 20 20 20C22.7625 20 25 17.7625 25 15C25 12.2375 22.7625 10 20 10ZM20 21.25C16.6625 21.25 10 22.925 10 26.25V30H30V26.25C30 22.925 23.3375 21.25 20 21.25Z",
    fill: "#46C35F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.2745bbcc34d66c1aed3ae5a2c71ac096.svg";
export { ForwardRef as ReactComponent };